import React from "react";
import { formatePriceFn, formatPrice } from "../../../../helper/commonFunction";
import { useSelector } from "react-redux";
import AedChargeNote from "../../../../component/AedChargeNote";
export const TourSummary = ({
  totalPrice,
  taxPrice,
  ageGroup,
  onlineServiceFeeAmount,
}) => {
  const { agentActiveCurrency,displayPrice } = useSelector((state) => state.userData);
  return (
    <div className="hw-passenger--fareSummary__table">
      {Object.keys(ageGroup)?.map((_ageGroup) => {
        if (ageGroup?.[_ageGroup]?.count <= 0) {
          return null;
        }
        return (
          <div className="hw-passenger--fareSummary__tbody">
            <div className="hw-passenger--fareSummary__tbodyTR">
              <span className="hw-black900 hw-fontBold hw-text14">
                {ageGroup?.[_ageGroup]?.name} x {ageGroup?.[_ageGroup]?.count}
              </span>
              <span className="hw-black900 hw-fontBold hw-text14">
              {formatePriceFn(agentActiveCurrency , formatPrice(ageGroup?.[_ageGroup]?.price * ageGroup?.[_ageGroup]?.count,false,false,true), displayPrice)}
              </span>
            </div>
          </div>
        );
      })}

      {taxPrice && taxPrice > 0 ? (
        <div className="hw-passenger--fareSummary__tbody">
          <div className="hw-passenger--fareSummary__tbodyTR">
            <span className="hw-black900 hw-fontBold hw-text14">Taxes and Fees</span>
            <span className="hw-black900 hw-fontBold hw-text14">
            {formatePriceFn(agentActiveCurrency , formatPrice(taxPrice,false,false,true), displayPrice)}
            </span>
          </div>
        </div>
      ) : null}

      {onlineServiceFeeAmount && onlineServiceFeeAmount > 0 ? (
        <div className="hw-passenger--fareSummary__tbody">
          <div className="hw-passenger--fareSummary__tbodyTR">
            <span className="hw-black900 hw-fontBold hw-text14">Service fee</span>
            <span className="hw-black900 hw-fontBold hw-text14">
            {formatePriceFn(agentActiveCurrency , formatPrice(onlineServiceFeeAmount,false,false,true), displayPrice)}
            </span>
          </div>
        </div>
      ) : null}

      <div className="hw-passenger--fareSummary__tfoot">
        <span className="hw-black900 hw-fontBold hw-text18">Total</span>
        <span className="hw-primary hw-fontBold">
        {formatePriceFn(agentActiveCurrency , onlineServiceFeeAmount && onlineServiceFeeAmount > 0
            ? formatPrice(totalPrice + onlineServiceFeeAmount, false, false,true)
            : formatPrice(totalPrice, false, false,true), displayPrice)}
        </span>
      </div>
      <AedChargeNote amount={onlineServiceFeeAmount && onlineServiceFeeAmount > 0 ? (totalPrice + onlineServiceFeeAmount) : totalPrice} currencyCode={agentActiveCurrency} />
    </div>
  );
};